<template>
  <div>
    <div class="select">
      <div class="select-item">
        所属地区 <el-select v-model="check.city_id" multiple collapse-tags placeholder="请选择" size="mini"
          style="width: 135px;" @change="doSearch">
          <el-option v-for="item in cityList" :key="item.city_code" :label="item.city" :value="item.city_code"
            :disabled="item.disabled">
          </el-option>
        </el-select>
      </div>
      <div class="select-item">
        招生快筛 <el-select v-model="check.teshu" multiple collapse-tags placeholder="请选择" size="mini" style="width: 145px;"
          @change="doSearch">
          <el-option key="1" label="普通类" :value="1">
          </el-option>
          <el-option key="2" label="中外合作" :value="2">
          </el-option>
          <el-option key="3" label="国家专项" :value="3">
          </el-option>
          <el-option key="4" label="地方专项" :value="4">
          </el-option>
          <el-option key="5" label="不组织专业考试的艺术类专业组" :value="5">
          </el-option>
          <el-option key="6" label="合作项目" :value="6">
          </el-option>
          <el-option key="7" label="定向" :value="7">
          </el-option>
          <el-option key="8" label="预科" :value="8">
          </el-option>
          <el-option key="9" label="单列专业" :value="9">
          </el-option>
        </el-select>
      </div>
      <div class="select-item">
        院校类型 <el-select v-model="check.school_type_id" multiple collapse-tags placeholder="请选择" size="mini"
          style="width: 135px;" @change="doSearch">
          <el-option v-for="item in schoolTypeList" :key="item.id" :label="item.name" :value="item.id"
            :disabled="item.disabled">
          </el-option>
        </el-select>
      </div>
      <div class="select-item">
        院校性质 <el-select v-model="check.nature_id" placeholder="请选择" clearable size="mini" style="width: 115px;"
          @change="doSearch">
          <el-option key="1" label="公办" :value="1">
          </el-option>
          <el-option key="2" label="民办" :value="2">
          </el-option>
          <el-option key="3" label="中外合作办学" :value="3">
          </el-option>
          <el-option key="4" label="内地与港澳台地区合作办学" :value="4">
          </el-option>
        </el-select>
      </div>
      <div class="select-item  select-item-last">
        院校特色 <el-select v-model="check.schoolTipId" multiple collapse-tags placeholder="请选择" size="mini"
          style="width: 145px;" @change="doSearch">
          <el-option v-for="item in schoolTipList" :key="item.value" :label="item.name" :value="item.id"
            :disabled="item.disabled">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="search-box">
      <div class="tabs">
        <el-row>
          <el-col :span="3"><span class="title">专业门类></span></el-col>
          <el-col :span="21">
            <span :class="{
              item: true,
              acts: levelId == null
            }" @click="allSpecialty()">全部</span>

            <el-badge :value="counts[item.specialty_code]" class="item" v-for="(item, i) in level" :key="i"
              type="primary">
              <span :class="{
                acts: levelId == item.specialty_code
              }" @click="getChildren(item)">
                {{ item.name }}
              </span>
            </el-badge>


          </el-col>
        </el-row>

        <el-divider class="search-line-condition"></el-divider>
        <el-row>
          <el-col :span="3"><span class="title">专业大类></span></el-col>
          <el-col :span="21">
            <span :class="{ item: true, }" @click="allChild">全部</span>
            <el-badge :value="counts1[item.specialty_code]" v-for="(item, i) in children" :key="i" class="item"
              type="primary">
              <span :class="{ acts: childId == item.specialty_code }" @click="getContent(item)">{{ item.name }}</span>
            </el-badge>
          </el-col>
        </el-row>

        <el-divider class="search-line-condition"></el-divider>
        <el-row>
          <el-col :span="3"><span class="title">专业名称></span></el-col>
          <el-col :span="21">
            <span :class="{ item: true, }" @click="allChilds()">全部</span>
            <span v-for="(item, i) in childrenList" :key="i"
              :class="{ act: CodeList.indexOf(item.specialty_code) > -1 }" @click="getSpeclatyCode(item)">{{
                item.name
              }}</span>
          </el-col>
        </el-row>

        <el-divider class="search-line-condition"></el-divider>
        <el-row>
          <el-col :span="3">
            <span class="title">推荐志愿></span>
          </el-col>
          <el-col :span="21">
            <span :class="{ item: true, act: check.level === null }" @click="choose('level', null, 0)">全部</span>
            <span :class="{ item: true, act: check.level === 1 }" style="color: #BB0000;"
              @click="choose('level', 1, 0)">难</span>
            <span :class="{ item: true, act: check.level === 2 }" @click="choose('level', 2, 0)">冲一冲</span>
            <span :class="{ item: true, act: check.level === 3 }" @click="choose('level', 3, 0)">稳一稳</span>
            <span :class="{ item: true, act: check.level === 4 }" @click="choose('level', 4, 0)">保一保</span>
          </el-col>
        </el-row>
      </div>
      <div class="specialty-search tianbao-search">
        <el-autocomplete v-model="specialty_name" style="width: 280px;float: right;"
          :fetch-suggestions="querySearchAsync" size="mini" placeholder="请输入专业名称" @select="handleSelect">
          <template slot-scope="{ item }">
            <div class="name">{{ item.name }}</div>
          </template>
          <el-button slot="append" class="btn" size="mini" type="primary">搜索</el-button>
        </el-autocomplete>
      </div>
    </div>
  </div>
</template>

<script>
import cityList from "@/assets/data/city_data";
export default {
  name: "",
  props: {
    value: Object,
    new_batch: String
  },
  data() {
    return {
      cityList: cityList,
      check: {

      },
      recruitUnitList: [
        {
          id: 2,
          name: "较高收费",
        },
        {
          id: 7,
          name: "其他单列",
        },
        {
          id: 4,
          name: "异地校区",
        },
        {
          id: 5,
          name: "医护类",
        },
        {
          id: 3,
          name: "少数民族",
        },
      ],
      schoolTypeList: [
        {
          id: "17",
          name: "财经类",
        },
        {
          id: "18",
          name: "理工类",
        },
        {
          id: "19",
          name: "农林类",
        },
        {
          id: "20",
          name: "综合类",
        },
        {
          id: "21",
          name: "政法类",
        },
        {
          id: "22",
          name: "师范类",
        },
        {
          id: "23",
          name: "语言类",
        },
        {
          id: "24",
          name: "医药类",
        },
        {
          id: "26",
          name: "民族类",
        },
        {
          id: "27",
          name: "艺术类",
        },
        {
          id: "28",
          name: "体育类",
        },
        {
          id: "29",
          name: "军事类",
        },
      ],
      schoolTipList: [
        {
          id: "11",
          name: "C9",
          type: "0",
        },
        {
          id: "5",
          name: "985",
          type: "0",
        },
        {
          id: "6",
          name: "211",
          type: "0",
        },
        {
          id: "7",
          name: "双一流",
          type: "0",
        },
        {
          id: "13",
          name: "国家示范",
          type: "0",
        },
        {
          id: "14",
          name: "国家骨干",
          type: "0",
        },
        {
          id: "15",
          name: "双高计划",
          type: "0",
        },
      ],
      specialty_name: '',
      levelId: null,
      childId: null,

      level: [],
      children: [],
      childrenList: [],
      loading: false,
      CodeList: [],

      NumList: [],
      NumList1: [],
      counts: [],
      counts1: [],
      status1: false,
      status2: false
    };
  },
  watch: {
    new_batch() {
      this.CodeList = []
      this.getLevel()
    }
  },
  created() {
    this.check = this.value
    this.getLevel();
  },


  methods: {
    doSearch() {
      this.$emit("onSearch", this.check);
    },

    //选择条件
    choose(type, val, isArr) {
      if (isArr === 1) {
        if (val === -1) {
          this.check[type] = [];
        } else {
          const index = this.check[type].indexOf(val);
          if (index > -1) {
            this.check[type].splice(index, 1);
          } else {
            this.check[type].push(val);
          }
        }
      } else if (isArr === 0) {
        this.check[type] = val;
      }
      this.$emit("onSearch", this.check);
    },

    //获取门类列表
    getLevel() {
      console.log(this.new_batch)
      let id = 0
      if (this.new_batch == 1) {
        id = 0
      } else {
        id = 1
      }
      this.$fecth.post("Specialty/getSpecialty", { degree: id }).then((res) => {
        this.level = res;
        this.getChildren(res[0]);
      });
    },


    // 获取大类
    getChildren(item) {
      this.levelId = item.specialty_code;
      this.loading = true;
      this.$fecth
        .post("Specialty/getSpecialtyChild", {
          specialty_code: item.specialty_code,
        })
        .then((res) => {
          this.children = res;
          this.childrenList = this.children[0].childrens;
          this.childId = this.children[0].specialty_code;
          this.loading = false;
        });
    },
    //获取专业
    getContent(item) {
      this.childId = item.specialty_code;
      this.childrenList = item.childrens;
    },

    getSpeclatyCode(item) {
      if (this.CodeList.indexOf(item.specialty_code) > -1) {
        this.CodeList.splice(this.CodeList.indexOf(item.specialty_code), 1);
      } else {
        this.CodeList.push(item.specialty_code)
      }
      this.getParent()
      this.check.code_list = this.CodeList
      this.$emit("onSearch", this.check);
    },

    getParent() {
      this.NumList = []
      this.NumList1 = []
      this.CodeList.forEach((item) => {
        this.NumList.push(item.substring(0, 2))
        this.NumList1.push(item.substring(0, 4))
      })
      this.countDuplicates()
    },

    countDuplicates() {
      let counts = {};
      let counts1 = {};
      this.NumList.forEach(item => {
        if (counts[item]) {
          counts[item]++;
        } else {
          counts[item] = 1;
        }
      });
      this.NumList1.forEach(item => {
        if (counts1[item]) {
          counts1[item]++;
        } else {
          counts1[item] = 1;
        }
      });
      this.counts = counts
      this.counts1 = counts1
    },


    allSpecialty() {
      this.levelId = null
      this.CodeList = []
      this.check.code_list = this.CodeList
      this.getParent()
      this.$emit("onSearch", this.check);
    },

    allChild() {
      if (this.status1) {
        this.children.forEach(item => {
          item.childrens.forEach(val => {
            if (this.CodeList.indexOf(val.specialty_code) > -1) {
              this.CodeList.splice(this.CodeList.indexOf(val.specialty_code), 1);
              this.CodeList.push(val.specialty_code)
            } else {
              this.CodeList.push(val.specialty_code)
            }

          })
        })
      } else {
        this.children.forEach(item => {
          item.childrens.forEach(val => {
            if (this.CodeList.indexOf(val.specialty_code) > -1) {
              this.CodeList.splice(this.CodeList.indexOf(val.specialty_code), 1);
            }
          })
        })
      }
      this.status1 = !this.status1
      this.check.code_list = this.CodeList
      this.getParent()
      this.$emit("onSearch", this.check);
    },

    allChilds() {
      if (this.status2) {
        this.childrenList.forEach(item => {
          if (this.CodeList.indexOf(item.specialty_code) > -1) {
            this.CodeList.splice(this.CodeList.indexOf(item.specialty_code), 1);
            this.CodeList.push(item.specialty_code)
          } else {
            this.CodeList.push(item.specialty_code)
          }
        })
      } else {
        this.childrenList.forEach(item => {
          if (this.CodeList.indexOf(item.specialty_code) > -1) {
            this.CodeList.splice(this.CodeList.indexOf(item.specialty_code), 1);
          }
        })
      }
      this.status2 = !this.status2
      this.check.code_list = this.CodeList
      this.getParent()
      this.$emit("onSearch", this.check);
    },
    querySearchAsync(queryString, cb) {

      if (queryString) {
        this.$fecth
          .post("volunteer_demand/getSpecialtyList", {
            name: queryString,
            degree: 0,
          })
          .then((res) => {
            var results = res

            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
              cb(results);
            }, 3000 * Math.random());
          });
      }
    },

    handleSelect(item) {
      this.getSpeclatyCode(item)
    }

  },
};
</script>

<style lang="less">
.el-badge__content.is-fixed {
  right: 25px;
}
</style>

<style scoped lang='less'>
.old_search {
  border: 1px solid #f3f3f3;
  background: #f3f3f3;
  padding: 3px 7px;
  border-radius: 10px;
  font-size: 12px;
  margin-right: 10px;
}

.search-box {
  margin: 0 0 20px;
  position: relative;

  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.3s ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }


  .tabs {
    color: #666666;
    letter-spacing: 2px;
    padding: 15px 0 0 0;
    margin-bottom: 15px;
    font-size: 16px;
    position: relative;

    .title {
      color: #333333;
      font-weight: 500;
      text-align: center;
    }

    span {
      display: inline-block;
      padding: 0 6px;
      line-height: 27px;
      margin-bottom: 3px;
      margin-right: 12px;

      &:hover {
        background: #2B7BF3;
        color: white;
      }
    }
  }

  .act {
    background-color: #2B7BF3;
    color: #ffffff;
  }

  .act1 {
    background-color: #bd01ad;
    color: #ffffff;
  }

  .acts {
    background-color: #00e9ff30;
  }
}

.search-line-condition {
  margin: 7px 0;
}

.tianbao-search {
  height: 25px;
  font-size: 16px;

  .btn {
    background: #2B7BF3;
    color: white;
    border-radius: 0 3px 3px 0;
    border: 1px solid #2B7BF3;
  }
}
</style>

<style lang="less" scoped>
.select {
  color: #3D3D3D;
  font-size: 18px;
  padding: 0 5px;
  margin-bottom: 15px;

  .select-item {
    display: inline-block;
    margin-right: 30px;
    margin-bottom: 10px;
  }

  .select-item-last {
    margin-right: 0px;
    float: right;
  }
}
</style>
